import React, { useEffect, useRef, useState } from "react";
import KeyboardArrowDownOutlinedIcon from "@mui/icons-material/KeyboardArrowDownOutlined";

const PortalV2Select = ({
  label,
  value,
  options,
  onChange,
  className = "",
  layout = "inline",
  required = false,
  placeholder = "Select",
}) => {
  const [open, setOpen] = useState(false);
  const rootRef = useRef(null);
  const isField = layout === "field";

  const selected = options.find((opt) => opt.value === value);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (rootRef.current && !rootRef.current.contains(event.target)) {
        setOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const selectControl = (
    <div className={`portal-v2-select ${isField ? "portal-v2-select--block" : ""} ${open ? "is-open" : ""}`}>
      {!isField && label ? <span className="portal-v2-select__label">{label}</span> : null}
      <button
        type="button"
        className={`portal-v2-select__trigger ${isField ? "portal-v2-select__trigger--block" : ""}`}
        onClick={() => setOpen((prev) => !prev)}
        aria-haspopup="listbox"
        aria-expanded={open}
      >
        <span className={`portal-v2-select__value ${!selected ? "is-placeholder" : ""}`}>
          {selected?.label || placeholder}
        </span>
        <KeyboardArrowDownOutlinedIcon className="portal-v2-select__chevron" />
      </button>
      {open && (
        <ul
          className={`portal-v2-select__menu ${isField ? "portal-v2-select__menu--block" : ""}`}
          role="listbox"
        >
          {options.map((opt) => (
            <li key={opt.value} role="option" aria-selected={opt.value === value}>
              <button
                type="button"
                className={`portal-v2-select__option ${opt.value === value ? "is-selected" : ""}`}
                onMouseDown={(e) => e.preventDefault()}
                onClick={() => {
                  onChange(opt.value);
                  setOpen(false);
                }}
              >
                {opt.label}
              </button>
            </li>
          ))}
        </ul>
      )}
    </div>
  );

  if (isField) {
    return (
      <div className={`portal-v2-select-field ${className}`} ref={rootRef}>
        {label ? (
          <span className="portal-v2-select-field__label">
            {label}
            {required ? <em>*</em> : null}
          </span>
        ) : null}
        {selectControl}
      </div>
    );
  }

  return (
    <div className={`portal-v2-select-wrap ${className}`} ref={rootRef}>
      {selectControl}
    </div>
  );
};

export default PortalV2Select;
